import { useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";

// Menú flotante en portal: evita que los contenedores con overflow (como el
// cuerpo desplazable de Modal) recorten listas de búsqueda y selección.
export default function FloatingPopover({ anchorRef, children, className = "", align = "start", gap = 4, maxHeight = 256 }) {
  const [style, setStyle] = useState(null);

  useLayoutEffect(() => {
    const place = () => {
      const anchor = anchorRef.current;
      if (!anchor) return;
      const rect = anchor.getBoundingClientRect();
      const margin = 8;
      const below = window.innerHeight - rect.bottom - gap - margin;
      const above = rect.top - gap - margin;
      const openUp = below < Math.min(maxHeight, 180) && above > below;
      const height = Math.max(80, Math.min(maxHeight, openUp ? above : below));
      const width = Math.min(rect.width, window.innerWidth - margin * 2);
      const left = align === "end"
        ? Math.max(margin, Math.min(rect.right - width, window.innerWidth - width - margin))
        : Math.max(margin, Math.min(rect.left, window.innerWidth - width - margin));
      setStyle({ position: "fixed", left, top: openUp ? undefined : rect.bottom + gap, bottom: openUp ? window.innerHeight - rect.top + gap : undefined, width, maxHeight: height });
    };
    place();
    window.addEventListener("resize", place);
    window.addEventListener("scroll", place, true);
    return () => {
      window.removeEventListener("resize", place);
      window.removeEventListener("scroll", place, true);
    };
  }, [anchorRef, align, gap, maxHeight]);

  if (!style) return null;
  return createPortal(
    <div style={style} className={`z-[70] overflow-y-auto overscroll-contain ${className}`}>{children}</div>,
    document.body
  );
}
